import classNames from 'classnames';
import * as yup from 'yup';
import { Formik, Form, FieldArray } from 'formik';

import { Modal } from '../../../modal/Modal';
import { Button } from '../basic-ui/Button';
import { Input } from '../basic-ui/Input';
import { BUTTON_TYPES } from '../../constants';

import PlusIcon from '@crazyegginc/hatch/dist/images/icon-plus.svg?react';
import CrossIcon from '@crazyegginc/hatch/dist/images/icon-cross.svg?react';

const validationSchema = yup.object().shape({
  referrers: yup
    .array()
    .of(
      yup
        .string()
        .required('Please provide a referrer.')
        .matches(/[^\s]+/, 'Please provide a valid referrer.'),
    )
    .min(1, 'Please provide at least one referrer.'),
});

export function ReferrerSegmentModal({ onCancel, onSubmit, values }) {
  return (
    <Modal dialogClassName="!top-[150px] !translate-y-0" onDismiss={onCancel}>
      <Modal.Title>Referrer</Modal.Title>
      <div className="text-white font-semibold leading-none mt-[25px] mb-1.25">
        Enter referrer URL (wildcards are supported)
      </div>
      <Formik
        initialValues={{ referrers: values ?? [''] }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSubmit(values.referrers);
        }}
      >
        {({ values, errors, touched, handleBlur, handleChange, setFieldValue }) => (
          <Form>
            <FieldArray name="referrers">
              {(actions) => (
                <>
                  <div className="max-h-[220px] overflow-y-auto -mr-5 pr-5 styled-scrollbar">
                    {values.referrers.map((referrer, i) => (
                      <div className="relative flex items-start mt-1.25 first:mt-0 group" key={`referrer-${i}`}>
                        <Input
                          size="lg"
                          className="pr-9"
                          aria-label={`referrer ${i}`}
                          placeholder="referrer.com/*"
                          name={`referrers[${i}]`}
                          value={values.referrers[i]}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.referrers?.[i] && errors.referrers?.[i] ? errors.referrers?.[i] : null}
                        />
                        {values.referrers?.length > 1 && (
                          <button
                            type="button"
                            className={classNames(
                              'text-gray-200 hover:text-white p-1',
                              'items-center justify-center shrink-0',
                              'absolute right-3 top-2.5 duration-75 hover:transition-all',
                              'hidden group-hover:flex',
                            )}
                            onClick={() => actions.remove(i)}
                          >
                            <CrossIcon className="h-2.5 w-2.5 fill-current" aria-label={`delete referrer ${i}`} />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={() => actions.push('')}
                    className="flex items-center text-gray-200 hover:text-white font-semibold mt-[15px] duration-75 hover:transition-all"
                  >
                    <PlusIcon className="mr-2 h-2.5 w-2.5 fill-current" />
                    Add another URL
                  </button>
                </>
              )}
            </FieldArray>
            <div className="flex items-center justify-between mt-[30px]">
              <Button size="lg" variant={BUTTON_TYPES.SECONDARY} onClick={() => setFieldValue('referrers', [''])}>
                Clear all
              </Button>
              <div className="flex items-center space-x-2.5">
                <Modal.Cancel onClick={onCancel} />
                <Button type="submit" size="lg">
                  Apply
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
